import qs from 'qs';
import { config } from './consts';

export const enabledOauthProviders = async () => {
    const response = await fetch(
        `${config.apiURL}/v2/oauth/providers?${qs.stringify({ site_url: config.formURL })}`,
        {
            method: 'GET',
            headers: { Accept: 'application/json' }
        }
    );
    const parsedRes = await response.json();

    return { [response.ok ? 'res' : 'err']: parsedRes };
};

export const getToken = async () => {
    const response = await fetch(`${config.apiURL}/v1/token`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({}),
        referrer: 'https://www.wallarm.com/',
        referrerPolicy: 'strict-origin-when-cross-origin',
        mode: 'cors',
        credentials: 'include'
    });
    const parsedRes = await response.json();

    return { [response.ok ? 'res' : 'err']: parsedRes.body || parsedRes };
};

export const getUser = async (token: string) => {
    const response = await fetch(`${config.apiURL}/v1/user`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token }),
        referrer: 'https://www.wallarm.com/',
        referrerPolicy: 'strict-origin-when-cross-origin',
        mode: 'cors',
        credentials: 'include'
    });
    const parsedRes = await response.json();

    return { [response.ok ? 'res' : 'err']: parsedRes.body || parsedRes };
};

export const getUsersEmail = async () => {
    let email = '';

    const { res } = await getToken();
    if (res?.token) {
        const user = await getUser(res?.token);
        if (user?.res) email = user.res.email;
    }

    return email;
};
